// frontend/src/services/api.ts
import axios from 'axios';

const API_URL = 'https://train.callgenius.cloud/api';

const api = axios.create({
  baseURL: API_URL,
});

// Intercepteur pour gérer les erreurs d'authentification
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expiré ou invalide
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
